// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/api/organizations/firstparty/v5/get_capital_deposit.proto

/* oxlint-disable */
import { ApiTimestamp } from "../../../../../../google/protobuf/timestamp";

/** Possible statuses for the capital deposit. */
export const ApiDepositCapitalStatus = {
  /** DEPOSIT_CAPITAL_STATUS_UNSPECIFIED - Unspecified status */
  DEPOSIT_CAPITAL_STATUS_UNSPECIFIED: "DEPOSIT_CAPITAL_STATUS_UNSPECIFIED",
  /**
   * waiting - Waiting
   */
  waiting: "waiting",
  /**
   * uncompleted - Uncompleted
   */
  uncompleted: "uncompleted",
  /**
   * mismatch - Mismatch
   */
  mismatch: "mismatch",
  /**
   * deposit_request_sent - Deposit request sent
   */
  deposit_request_sent: "deposit_request_sent",
  /**
   * deposit_request_signed - Deposit request signed
   */
  deposit_request_signed: "deposit_request_signed",
  /**
   * reviewed - Reviewed
   */
  reviewed: "reviewed",
  /**
   * capital_transferred - Capital transferred
   */
  capital_transferred: "capital_transferred",
  /**
   * deposit_certificate_sent - Deposit certificate sent
   */
  deposit_certificate_sent: "deposit_certificate_sent",
  /**
   * deposit_certificate_signed - Deposit certificate signed
   */
  deposit_certificate_signed: "deposit_certificate_signed",
  /**
   * kbis_submitted - KBIS submitted
   */
  kbis_submitted: "kbis_submitted",
  /**
   * deposit_release_sent - Deposit release sent
   */
  deposit_release_sent: "deposit_release_sent",
  /**
   * deposit_release_requested - Deposit release requested
   */
  deposit_release_requested: "deposit_release_requested",
  /**
   * capital_released - Capital released
   */
  capital_released: "capital_released",
  /**
   * awaiting_documents - Awaiting documents
   */
  awaiting_documents: "awaiting_documents",
  /**
   * pending_review - Pending review
   */
  pending_review: "pending_review",
  /**
   * awaiting_shareholders - Awaiting shareholders
   */
  awaiting_shareholders: "awaiting_shareholders",
} as const;

export type ApiDepositCapitalStatus = typeof ApiDepositCapitalStatus[keyof typeof ApiDepositCapitalStatus];

export namespace ApiDepositCapitalStatus {
  export type DEPOSIT_CAPITAL_STATUS_UNSPECIFIED = typeof ApiDepositCapitalStatus.DEPOSIT_CAPITAL_STATUS_UNSPECIFIED;
  export type waiting = typeof ApiDepositCapitalStatus.waiting;
  export type uncompleted = typeof ApiDepositCapitalStatus.uncompleted;
  export type mismatch = typeof ApiDepositCapitalStatus.mismatch;
  export type deposit_request_sent = typeof ApiDepositCapitalStatus.deposit_request_sent;
  export type deposit_request_signed = typeof ApiDepositCapitalStatus.deposit_request_signed;
  export type reviewed = typeof ApiDepositCapitalStatus.reviewed;
  export type capital_transferred = typeof ApiDepositCapitalStatus.capital_transferred;
  export type deposit_certificate_sent = typeof ApiDepositCapitalStatus.deposit_certificate_sent;
  export type deposit_certificate_signed = typeof ApiDepositCapitalStatus.deposit_certificate_signed;
  export type kbis_submitted = typeof ApiDepositCapitalStatus.kbis_submitted;
  export type deposit_release_sent = typeof ApiDepositCapitalStatus.deposit_release_sent;
  export type deposit_release_requested = typeof ApiDepositCapitalStatus.deposit_release_requested;
  export type capital_released = typeof ApiDepositCapitalStatus.capital_released;
  export type awaiting_documents = typeof ApiDepositCapitalStatus.awaiting_documents;
  export type pending_review = typeof ApiDepositCapitalStatus.pending_review;
  export type awaiting_shareholders = typeof ApiDepositCapitalStatus.awaiting_shareholders;
}

export function apiDepositCapitalStatusFromJSON(object: any): ApiDepositCapitalStatus {
  switch (object) {
    case 0:
    case "DEPOSIT_CAPITAL_STATUS_UNSPECIFIED":
      return ApiDepositCapitalStatus.DEPOSIT_CAPITAL_STATUS_UNSPECIFIED;
    case 1:
    case "waiting":
      return ApiDepositCapitalStatus.waiting;
    case 2:
    case "uncompleted":
      return ApiDepositCapitalStatus.uncompleted;
    case 3:
    case "mismatch":
      return ApiDepositCapitalStatus.mismatch;
    case 4:
    case "deposit_request_sent":
      return ApiDepositCapitalStatus.deposit_request_sent;
    case 5:
    case "deposit_request_signed":
      return ApiDepositCapitalStatus.deposit_request_signed;
    case 6:
    case "reviewed":
      return ApiDepositCapitalStatus.reviewed;
    case 7:
    case "capital_transferred":
      return ApiDepositCapitalStatus.capital_transferred;
    case 8:
    case "deposit_certificate_sent":
      return ApiDepositCapitalStatus.deposit_certificate_sent;
    case 9:
    case "deposit_certificate_signed":
      return ApiDepositCapitalStatus.deposit_certificate_signed;
    case 10:
    case "kbis_submitted":
      return ApiDepositCapitalStatus.kbis_submitted;
    case 11:
    case "deposit_release_sent":
      return ApiDepositCapitalStatus.deposit_release_sent;
    case 12:
    case "deposit_release_requested":
      return ApiDepositCapitalStatus.deposit_release_requested;
    case 13:
    case "capital_released":
      return ApiDepositCapitalStatus.capital_released;
    case 14:
    case "awaiting_documents":
      return ApiDepositCapitalStatus.awaiting_documents;
    case 15:
    case "pending_review":
      return ApiDepositCapitalStatus.pending_review;
    case 16:
    case "awaiting_shareholders":
      return ApiDepositCapitalStatus.awaiting_shareholders;
    default:
      return ApiDepositCapitalStatus.DEPOSIT_CAPITAL_STATUS_UNSPECIFIED;
  }
}

export function apiDepositCapitalStatusToJSON(object: ApiDepositCapitalStatus): string {
  switch (object) {
    case ApiDepositCapitalStatus.DEPOSIT_CAPITAL_STATUS_UNSPECIFIED:
      return "DEPOSIT_CAPITAL_STATUS_UNSPECIFIED";
    case ApiDepositCapitalStatus.waiting:
      return "waiting";
    case ApiDepositCapitalStatus.uncompleted:
      return "uncompleted";
    case ApiDepositCapitalStatus.mismatch:
      return "mismatch";
    case ApiDepositCapitalStatus.deposit_request_sent:
      return "deposit_request_sent";
    case ApiDepositCapitalStatus.deposit_request_signed:
      return "deposit_request_signed";
    case ApiDepositCapitalStatus.reviewed:
      return "reviewed";
    case ApiDepositCapitalStatus.capital_transferred:
      return "capital_transferred";
    case ApiDepositCapitalStatus.deposit_certificate_sent:
      return "deposit_certificate_sent";
    case ApiDepositCapitalStatus.deposit_certificate_signed:
      return "deposit_certificate_signed";
    case ApiDepositCapitalStatus.kbis_submitted:
      return "kbis_submitted";
    case ApiDepositCapitalStatus.deposit_release_sent:
      return "deposit_release_sent";
    case ApiDepositCapitalStatus.deposit_release_requested:
      return "deposit_release_requested";
    case ApiDepositCapitalStatus.capital_released:
      return "capital_released";
    case ApiDepositCapitalStatus.awaiting_documents:
      return "awaiting_documents";
    case ApiDepositCapitalStatus.pending_review:
      return "pending_review";
    case ApiDepositCapitalStatus.awaiting_shareholders:
      return "awaiting_shareholders";
    default:
      return "DEPOSIT_CAPITAL_STATUS_UNSPECIFIED";
  }
}

/** Request for getting capital deposit information for an organization. */
export interface ApiGetCapitalDepositRequest {
  /** The organization ID. */
  readonly id: string;
}

/** Response containing capital deposit information. */
export interface ApiGetCapitalDepositResponse {
  /** Timestamp when the bylaw was uploaded. */
  readonly bylawUploadedAt?:
    | Date
    | null
    | undefined;
  /** Whether the company is being created from scratch. */
  readonly companyCreationFromScratch: boolean;
  /** Type of deposit capital flow. */
  readonly depositCapitalFlowType?:
    | string
    | null
    | undefined;
  /** Status of thecapital deposit. */
  readonly depositCapitalStatus?:
    | ApiDepositCapitalStatus
    | null
    | undefined;
  /** Whether the organization is under registration. */
  readonly underRegistration: boolean;
  /** Provider source contact email (eg. accountant email). */
  readonly providerSourceContactEmail?:
    | string
    | null
    | undefined;
  /** Bylaw OCR extraction happened successfully before. */
  readonly bylawOcrSuccessful: boolean;
  /** Provider source */
  readonly providerSource?: string | null | undefined;
}

export const ApiGetCapitalDepositRequest: MessageFns<ApiGetCapitalDepositRequest> = {
  fromJSON(object: any): ApiGetCapitalDepositRequest {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: ApiGetCapitalDepositRequest): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    return obj;
  },
};

export const ApiGetCapitalDepositResponse: MessageFns<ApiGetCapitalDepositResponse> = {
  fromJSON(object: any): ApiGetCapitalDepositResponse {
    return {
      bylawUploadedAt: isSet(object.bylawUploadedAt) ? fromJsonTimestamp(object.bylawUploadedAt) : null,
      companyCreationFromScratch: isSet(object.companyCreationFromScratch)
        ? globalThis.Boolean(object.companyCreationFromScratch)
        : false,
      depositCapitalFlowType: isSet(object.depositCapitalFlowType)
        ? globalThis.String(object.depositCapitalFlowType)
        : null,
      depositCapitalStatus: isSet(object.depositCapitalStatus)
        ? apiDepositCapitalStatusFromJSON(object.depositCapitalStatus)
        : null,
      underRegistration: isSet(object.underRegistration) ? globalThis.Boolean(object.underRegistration) : false,
      providerSourceContactEmail: isSet(object.providerSourceContactEmail)
        ? globalThis.String(object.providerSourceContactEmail)
        : null,
      bylawOcrSuccessful: isSet(object.bylawOcrSuccessful) ? globalThis.Boolean(object.bylawOcrSuccessful) : false,
      providerSource: isSet(object.providerSource) ? globalThis.String(object.providerSource) : null,
    };
  },

  toJSON(message: ApiGetCapitalDepositResponse): unknown {
    const obj: any = {};
    if (message.bylawUploadedAt !== undefined && message.bylawUploadedAt !== null) {
      obj.bylawUploadedAt = message.bylawUploadedAt.toISOString();
    }
    if (message.companyCreationFromScratch !== undefined && message.companyCreationFromScratch !== null) {
      obj.companyCreationFromScratch = message.companyCreationFromScratch;
    }
    if (message.depositCapitalFlowType !== undefined && message.depositCapitalFlowType !== null) {
      obj.depositCapitalFlowType = message.depositCapitalFlowType;
    }
    if (message.depositCapitalStatus !== undefined && message.depositCapitalStatus !== null) {
      obj.depositCapitalStatus = apiDepositCapitalStatusToJSON(message.depositCapitalStatus);
    }
    if (message.underRegistration !== undefined && message.underRegistration !== null) {
      obj.underRegistration = message.underRegistration;
    }
    if (message.providerSourceContactEmail !== undefined && message.providerSourceContactEmail !== null) {
      obj.providerSourceContactEmail = message.providerSourceContactEmail;
    }
    if (message.bylawOcrSuccessful !== undefined && message.bylawOcrSuccessful !== null) {
      obj.bylawOcrSuccessful = message.bylawOcrSuccessful;
    }
    if (message.providerSource !== undefined && message.providerSource !== null) {
      obj.providerSource = message.providerSource;
    }
    return obj;
  },
};

function fromTimestamp(t: ApiTimestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(ApiTimestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
